import { render, staticRenderFns } from "./SaiMultiSelect.vue?vue&type=template&id=b49dd854"
import script from "./SaiMultiSelect.vue?vue&type=script&lang=js"
export * from "./SaiMultiSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports